import React from "react";
import { Col } from "react-bootstrap";
import ImageSection from "./ImageSection";

function DesktopVideo({ resultArray }) {
  const array1 = resultArray[0];
  const array2 = resultArray[1];
  const array3 = resultArray[2];
  return (
    <Col lg={6} className="d-none d-lg-flex justify-content-center position-relative h-100 overflow-hidden">
      <div className="slide-vertical st1">
        <ImageSection resultArray={array1} className="imgbox" />
        <ImageSection resultArray={array1} className="imgbox" />
        <ImageSection resultArray={array1} className="imgbox" />
      </div>
      <div className="slide-vertical st2">
        <ImageSection resultArray={array2} className="imgbox" />
        <ImageSection resultArray={array2} className="imgbox" />
        <ImageSection resultArray={array2} className="imgbox" />
      </div>
      <div className="slide-vertical st3">
        <ImageSection resultArray={array3} className="imgbox" />
        <ImageSection resultArray={array3} className="imgbox" />
        <ImageSection resultArray={array3} className="imgbox" />
      </div>
    </Col>
  );
}
export default DesktopVideo;
